import Vue from 'vue'
import Router from 'vue-router'
import AboutMe from '@/components/AboutMe'
import Resume from '@/components/Resume'
import Blog from '@/components/Blog'
import Works from '@/components/Works'
import Contact from '@/components/Contact'
import gallery from '@/test/gallery2'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        redirect: '/AboutMe'
    }, {
        path: '/AboutMe',
        name: 'AboutMe',
        component: AboutMe
    }, {
        path: '/AboutMe',
        name: 'AboutMe',
        component: AboutMe
    }, {
        path: '/Resume',
        name: 'Resume',
        component: Resume
    }, {
        path: '/Blog',
        name: 'Blog',
        component: Blog
    }, {
        path: '/Works',
        name: 'Works',
        component: Works
    }, {
        path: '/Contact',
        name: 'Contact',
        component: Contact
    }, {
        path: '/gallery',
        name: 'gallery',
        component: gallery
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js